import { HttpParams } from '@angular/common/http';
import { UrlList } from 'app/main/pages/authentication/shared/url-list.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ChannelsService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
    }
    getChannelActiveByCustomerUserIdObservable(customerUserId, active) {
        const params = new HttpParams()
            .set('customerUserId', customerUserId.toString())
            .set('active', active.toString());
        return this._httpClient.get(UrlList.URL_ROOMS + '/channelsByUser', { params });
    }
    getChannelActiveByCustomerUserIdPromise(customerUserId, active) {
        const params = new HttpParams()
            .set('customerUserId', customerUserId.toString())
            .set('active', active.toString());
        return new Promise((resolve, reject) => {
            this._httpClient
                .get(UrlList.URL_ROOMS + '/channelsByUser', { params })
                .subscribe((response) => {
                resolve(response);
            }, error => reject(error));
        });
    }
}
ChannelsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChannelsService_Factory() { return new ChannelsService(i0.ɵɵinject(i1.HttpClient)); }, token: ChannelsService, providedIn: "root" });
